<!-- Re-upload Invoice Popup -->
<div class="common-popup-container add-user-account-popup doc-upload-popup-wrapper">

    <!-- Main Form -->
    <div *ngIf="!isSubmitted">
        <h3 class="title mb-0">{{ 'INVOICE_POPUP.REUPLOAD_INVOICE' | translate }}</h3>

        <div class="yellow-container">
            <!-- Invoice Info -->
            <div class="my-input-group" *ngIf="invoiceData">
                <label>{{ 'INVOICE_SUMMARY.NEW_QUOTATION_DOC' | translate }}</label>
                <div class="quotation-info">
                    <span class="quotation-id-badge">#{{ invoiceId }}</span>
                </div>
            </div>

            <!-- Existing Quotation Document -->
            <!-- <div class="my-input-group mt-2" *ngIf="existingQuotationFile">
                <label>{{ 'QUOTATIONNEW_SUMMARY.CURRENT_QUOTATION_DOC' | translate }}</label>

                <div class="doc-files bg-transparent p-0 m-0">
                    <div class="file-attachment-container flex-one mt-0">
                        <div class="file-attached-container flex-one mt-0">
                            <div class="attachment file-attachment flex-one justify-content-between m-0">
                                <div class="d-flex align-items-center mr-2">
                                    <img src="assets/images/new-set/pdf-icon.svg">
                                    <span class="file-name doc-name">{{ existingQuotationFile.fileName }}</span>
                                </div>
                                <a [href]="existingQuotationFile.fileUrl" target="_blank" class="view-link">
                                    <img src="assets/images/new-set/eye.svg" style="width: 20px;">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Existing Supporting Documents -->
            <!-- <div class="my-input-group mt-2" *ngIf="existingSupportingDocs && existingSupportingDocs.length > 0">
                <label>{{ 'QUOTATIONNEW_SUMMARY.CURRENT_SUPPORTING_DOCS' | translate }} ({{
                    existingSupportingDocs.length }})</label>

                <div class="file-attachment-container mt-2">
                    <div class="file-attached-container mt-2"
                        *ngFor="let doc of existingSupportingDocs; let idx = index">
                        <div class="attachment flex-one justify-content-between m-0">
                            <div class="d-flex align-items-center mr-2">
                                <img src="assets/images/new-set/pdf-icon.svg">
                                <div class="d-flex flex-column">
                                    <span class="file-name doc-name">{{ doc.fileName }}</span>
                                    <span class="file-size text-muted small" *ngIf="doc.fileSize > 0">{{
                                        getFileSize(doc.fileSize) }}</span>
                                </div>
                            </div>
                            <a [href]="doc.fileUrl" target="_blank" class="view-link">
                                <img src="assets/images/new-set/eye.svg" style="width: 20px;">
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- New Invoice Document -->
            <div class="my-input-group mt-3">
                <label>{{ 'INVOICE_SUMMARY.NEW_SUPPORTING_DOC' | translate }}</label>

                <div class="doc-files bg-transparent p-0 m-0">
                    <div class="file-attachment-container flex-one mt-0">
                        <div class="file-attached-container flex-one mt-0">
                            <div class="attachment file-attachment flex-one justify-content-between m-0">
                                <div class="d-flex align-items-center mr-2">
                                    <img [src]="getImageIcon(fileData)">
                                    <span class="file-name doc-name">{{ fileData?.fileName || 'No file selected'
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Supporting Documents Upload -->
        <div class="my-input-group mt-3">
            <label>
                {{ 'INVOICE_SUMMARY.NEW_SUPPORTING_DOC' | translate }}
                <div data-tooltip="You can upload supporting documents
                    related to the invoice, such as proposals or reference files (optional)"
                    class="comment-badge rounded common-tooltip-table fix-width d-inline ml-0">
                    <img src="assets/images/new-set/thick-info-gray.svg">
                </div>
            </label>

            <!-- File Upload Area -->
            <div class="file-upload-container upload-files-container" (click)="supportingFileInput.click()"
                style="cursor: pointer;">
                <img src="assets/images/thin-gray-upload.svg" class="upload-icon">
                <div class="upload-here ml-2">
                    <p class="upload-content drop-file">
                        <span>{{ 'INVOICE_SUMMARY.BROWSE_FILE' | translate }}</span>
                    </p>
                </div>
            </div>
            <input #supportingFileInput type="file" multiple (change)="onSupportingDocumentSelected($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png" hidden>

            <!-- Display Uploaded Supporting Documents -->
            <div class="file-attachment-container mt-2" *ngIf="supportingDocuments.length > 0">
                <div class="file-attached-container mt-2" *ngFor="let doc of supportingDocuments; let idx = index">
                    <div class="attachment flex-one justify-content-between m-0">
                        <div class="d-flex align-items-center mr-2">
                            <img [src]="getImageIcon(doc)">
                            <div class="d-flex flex-column">
                                <span class="file-name doc-name">{{ doc.fileName }}</span>
                                <span class="file-size text-muted small">{{ getFileSize(doc.fileSize) }}</span>
                            </div>
                        </div>
                        <img src="assets/images/new-set/close.svg" class="close-icon"
                            style="width: 16px; cursor: pointer;" (click)="removeSupportingDocument(idx)">
                    </div>
                </div>
            </div>
        </div>

        <!-- Description -->
        <div class="my-input-group mt-3">
            <label>{{ 'INVOICE_SUMMARY.DESCRIPTION' | translate }}</label>
            <textarea placeholder="{{ 'INVOICE_SUMMARY.ENTER_REUPLOAD_DESCRIPTION' | translate }}"
                [(ngModel)]="description" [ngClass]="{ 'is-invalid': descriptionError }" rows="4"></textarea>
            <div class="invalid-feedback" *ngIf="descriptionError">
                {{ descriptionError }}
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="column text-right mt-4">
            <button class="tertiary-cta big mr-3" (click)="cancel()" [disabled]="isSubmitting">
                {{ 'INVOICE_SUMMARY.CANCEL' | translate }}
            </button>
            <button class="primary-cta big" (click)="reuploadInvoice()" [disabled]="isSubmitting">
                <span *ngIf="!isSubmitting">{{ 'INVOICE_SUMMARY.REUPLOAD' | translate }}</span>
                <span *ngIf="isSubmitting">
                    <i class="fa fa-spinner fa-spin"></i> {{ 'INVOICE_SUMMARY.REUPLOADING' | translate }}
                </span>
            </button>
        </div>
    </div>

   
<div class="popup-backdrop" *ngIf="isSubmitted"></div>

    <!-- Success Popup -->
<div class="popup-wrapper"
     *ngIf="isSubmitted"
     (click)="$event.stopPropagation()">
    <!-- Success Overlay -->
<!-- <div class="success-overlay d-flex align-items-center justify-content-center"
     *ngIf="isSubmitted"
     (click)="$event.stopPropagation()"> -->

    <!-- Success Message -->
    <div class="d-flex align-items-center justify-content-center" *ngIf="isSubmitted">
        <div class="submitted-container">
             <img  src="assets/images/new-set/thin-cancel.svg" alt="" class="cancel-icon" (click)="closeSuccessPopup()">
            <h3 class="title mb-0">{{ 'QUOTATIONNEW_SUMMARY.TITLE' | translate }}</h3>
            <img src="assets/success-animation.gif">
            <p class="submit-text">{{ 'QUOTATIONNEW_SUMMARY.SUCCESS_MESSAGE' | translate }}</p>
        </div>
    </div>
</div>
</div>